import React from "react";

import Routes from "../Routes";
import UmbracoContent from "../containers/UmbracoContent";

import LogViewer from "./LogViewer";
import Header from "./Header";
import ErrorModal from "../containers/errorPages/ErrorModal";

const App = () => (
  <UmbracoContent>
    <main>
      {process.env.HRGO_DEBUG && <LogViewer />}
      <Header />
      <Routes />
      <ErrorModal></ErrorModal>
    </main>
  </UmbracoContent>
);

export default App;
